import { UserRound } from 'lucide-react';

import { Avatar, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';

type ClientListItemProps = {
  name?: string | null | { id: number; name: string };
  selected?: boolean;
  onClick?: () => void;
  color?: string | null;
};

function getInitials(name?: string | null) {
  if (!name) return undefined;

  const words = name
    ?.replace(/[^a-zA-Z\s]/g, '') // remove special characters
    .split(/\s+|-/) // split on space or dash
    .filter(Boolean);

  if (!words?.length) return undefined;

  const first = words[0][0] || '';
  const second = words.length > 1 ? words[1][0] : words[0][1] || '';

  return (first + second).toUpperCase();
}

export function AvatarName({ name, selected, onClick, color }: ClientListItemProps) {
  const nameToUse = typeof name === 'string' ? name : name?.name;
  const initials = getInitials(nameToUse);

  return (
    <div
      className={cn('flex items-center gap-2', selected && 'bg-muted border-y', color && 'gap-1')}
      onClick={onClick}
    >
      <Avatar className="h-6 w-6 rounded-sm bg-muted">
        <AvatarFallback className="font-small text-xs">
          {initials ?? <UserRound size={14} />}
        </AvatarFallback>
      </Avatar>
      <div className="flex items-center">
        {color && (
          <div className="flex h-[16px] w-[16px] min-w-[16px] items-center justify-center">
            <span className="block h-2 w-2 rounded-full" style={{ backgroundColor: color }} />
          </div>
        )}
        <span className="text-sm">{nameToUse}</span>
      </div>
    </div>
  );
}
